import { createContext, useCallback, useContext, useState } from 'react';

export const HoverContext = createContext<{
  hoveredPillId: string | null;
  setHoveredPillId: (id: string | null) => void;
}>({
  hoveredPillId: null,
  setHoveredPillId: () => {},
});

export const HoverWrapper = (props: any) => {
  const [hoveredPillId, setHoveredPillId] = useState<string | null>(null);

  return (
    <HoverContext.Provider value={{ hoveredPillId, setHoveredPillId }}>
      {props.children}
    </HoverContext.Provider>
  );
};

export const usePillHover = () => {
  const { setHoveredPillId, hoveredPillId } = useContext(HoverContext);

  const onPillHover = useCallback(
    (id: string, hovered: boolean) => {
      setHoveredPillId(hovered ? id : null);
    },
    [setHoveredPillId]
  );

  const isHovered = useCallback(
    (id: string) => {
      return hoveredPillId === id;
    },
    [hoveredPillId]
  );

  return { onPillHover, isHovered };
};
